<script>
import Loading from 'vue-loading-overlay';
import Form from '../../utils/Form';
import 'vue-loading-overlay/dist/vue-loading.css';
import IoRadio from './IoRadio';
import IoSwitch from './IoSwitch';
import RichTextEditor from './rte/RichTextEditor';
import IoColor from './IoColor';
import IoBarSelect from './IoBarSelect';
import IoToggleField from './IoToggleField';
import IoFilterables from './IoFilterables';
import IoFilterable from './IoFilterable';
import IoSelect from './IoSelect';

export default {
  name: 'IoForm',

  props: {
    defaults: {
      required: true,
    },
    inputTypes: {
      required: false,
      type: Object,
      default: () => ({}),
    },
    eventName: {
      required: false,
    },
    showLoader: {
      requried: false,
      default: true,
    },
    ajax: {
      required: false,
      default: true,
    },
    errors: {
      required: false,
      default: undefined,
    },
    valueHandling: {
      required: false,
      default: 'default',
    },
    emptyValueHandling: {
      required: false,
      default: 'default',
    },
    fileAction: {
      required: false,
    },
    useLoader: {
      required: false,
      type: Object,
      default: null,
    },
    parentComponent: {
      required: false,
    },
    hiddenFields: {
      required: false,
    },
    callback: {
      required: false,
    },
  },

  components: {
    Loading,
    IoRadio,
    IoSwitch,
    IoColor,
    IoBarSelect,
    IoToggleField,
    IoFilterables,
    IoFilterable,
    IoSelect,
    RichTextEditor,
  },

  data() {
    const form = new Form(this.defaults, this.inputTypes, false, this.valueHandling, this.emptyValueHandling);

    if (this.errors !== undefined) {
      form.errors.errors = this.errors;
    }

    if (this.fileAction !== undefined) {
      form.fileAction = this.fileAction;
    }

    return {
      loader: null,
      isLoading: false,
      form,
      is_mounted: false,
      files: {},
    };
  },

  computed: {
    parent() {
      return this.parentComponent || this.$parent;
    },
    ioForm() {
      return this;
    },
  },

  created() {
    if (this.eventName) {
      GlobalEvents.listen(`${this.eventName}.submit`, () => {
        this.submit();
      });
    }
  },

  mounted() {
    const hiddenFields = this.hiddenFields || {};

    for (let i = 0; i < Object.keys(hiddenFields).length; i += 1) {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = Object.keys(hiddenFields)[i];
      hiddenInput.value = hiddenFields[Object.keys(hiddenFields)[i]];
      this.$el.appendChild(hiddenInput);
    }

    const $methodInp = this.$el.querySelector('[name="_method"]');
    if ($methodInp !== null) {
      this.form.put('_method', $methodInp.value);
    }

    this.form.setEl(this.$el);

    if (this.useLoader === null) {
      const ComponentClass = Vue.extend(Loading);
      const instance = new ComponentClass({
        propsData: {
          'is-full-page': true,
        },
      });
      this.loader = instance.$mount();
      this.$el.prepend(this.loader.$el);
    } else {
      this.loader = this.useLoader;
    }

    if (this.ajax === true) {
      this.$el.addEventListener('submit', (e) => {
        e.preventDefault();
        this.submit();
      });
    }

    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'submit';
    hiddenInput.classList.add('d-none');
    this.$el.appendChild(hiddenInput);

    this.is_mounted = true;
  },

  methods: {
    refreshForm(defaults = {}, inputTypes = null) {
      if (inputTypes === null) {
        inputTypes = this.inputTypes;
      }
      const form = new Form(defaults, inputTypes, false, this.valueHandling, this.emptyValueHandling);
      if (this.errors !== undefined) {
        form.errors.errors = this.errors;
      }

      if (this.fileAction !== undefined) {
        form.fileAction = this.fileAction;
      }

      this.form = form;
    },
    onFileChange(e, name) {
      const files = e.target.files || e.dataTransfer.files;
      const nameParts = name.split('.');
      const setFormPath = (value) => {
        let target = this.form;
        for (let i = 0; i < nameParts.length - 1; i += 1) {
          target = target[nameParts[i]];
        }
        target[nameParts[nameParts.length - 1]] = value;
      };

      if (!files.length) {
        setFormPath(null);
        delete this.files[name];
      } else {
        setFormPath(files[0]);
        this.files[name] = true;
      }

      this.form.hasFiles = Object.keys(this.files).length > 0;
    },

    submit() {
      if (this.isLoading) {
        return false;
      }

      const action = this.$el.getAttribute('action');
      const method = this.$el.getAttribute('method').toLowerCase();

      if (this.showLoader) {
        this.loader.$data.isActive = 1;
      }

      this.isLoading = true;

      this.form.setEl(this.$el);

      return new Promise((resolve, reject) => {
        this.form[method](action)
          .then((response) => {
            if (typeof response.messages !== 'undefined') {
              GlobalEvents.fire('alert', response.messages);
            } else if (typeof response.message !== 'undefined') {
              GlobalEvents.fire('alert', [{
                type: 'success',
                message: response.message,
              }]);
            }
            this.loader.$data.isActive = 0;
            this.isLoading = false;

            GlobalEvents.fire('ajax-success', { response, form: this.form });

            resolve(response);
          })
          .catch((response) => {
            this.loader.$data.isActive = 0;
            this.isLoading = false;
            GlobalEvents.fire('ajax-fail', { response, form: this.form });
            if (typeof this.callback === 'function') {
              this.callback(response, this.form);
            }

            if (typeof this.callback === 'function') {
              this.callback(response, this.form);
            }

            reject(response);
          });
      });
    },
  },
};
</script>
